module.exports = __webpack_public_path__ + "static/media/world_rugby.d5e14d54.png";